<p-toast position="top-right"></p-toast>
<app-header *ngIf="!isPortal"></app-header>
<router-outlet />
<app-footer *ngIf="!isPortal && !isHideFooter"></app-footer>